const getPaginationButtons = (currentPage, totalPages) => {
  const maxButtons = 11; // Adjust this to change the total number of pagination buttons
  const pages = new Set([1, 2, totalPages - 1, totalPages]);

  // Add pages around current
  for (let i = currentPage - 2; i <= currentPage + 2; i++) {
    if (i > 1 && i < totalPages) {
      pages.add(i);
    }
  }

  // If too many pages, adjust
  while (pages.size > maxButtons) {
    if (currentPage <= 6) {
      // Remove from end if current page is near start
      pages.delete(Math.max(...pages));
    } else if (currentPage >= totalPages - 5) {
      // Remove from start if current page is near end
      pages.delete(Math.min(...pages));
    } else {
      // Remove farthest pages from current
      const maxVal = Math.max(...pages);
      const minVal = Math.min(...pages);
      if (currentPage - minVal > maxVal - currentPage) {
        pages.delete(minVal);
      } else {
        pages.delete(maxVal);
      }
    }
  }

  // Sort and add ellipses
  const sortedPages = Array.from(pages).sort((a, b) => a - b);
  const output = [];
  let last = 0;

  for (const num of sortedPages) {
    if (last < num - 1) output.push('...');
    output.push(num);
    last = num;
  }

  return output;
};

export default getPaginationButtons;
